import uuid from 'uuid/v1';

const generateAction = params => (payload, extras) => ({
  type: params.actionType,
  payload,
  extras: { ...extras, uuid: uuid(), ...(params.actionExtras ? params.actionExtras(uuid()) : {}) },
});

export default generateAction;
